<ng-template #user_authentication let-offcanvas>
  <div class="{{localService.selectedLanguageCode}}"
    *ngIf="localService.languageContent && localService.languageContent.user_authentication">
    <div class="side_popup_header">
      <span>{{localService.languageContent.user_authentication.header}}</span>
      <button class="button_icon" (click)="onCloseTrigger()">close</button>
    </div>
    <div class="side_popup_body" [ngStyle]="{'max-height' : (localService.sideBarBodyHeight + 50) + 'px'}">
      <div *ngIf="wrapper">
        <div class="row" *ngIf="isMultiCustomerTypes">
          <div class="col-12">
            <div class="row">
              <div class="col-12">
                <label style="margin-left: 30px;font-weight: normal;">
                  <input type="radio" name="customer_type" [checked]="!isForBusiness" (click)="onChecked(1)">
                  <span>{{localService.languageContent.billing.customer}}</span>
                </label>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <label style="margin-left: 30px;font-weight:normal;">
                  <input type="radio" name="customer_type" [checked]="isForBusiness" (click)="onChecked(2)">
                  <span>{{localService.languageContent.billing.biz_customer}}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="isMultiCustomerTypes">
          <div class="col-12">
            &nbsp;
          </div>
        </div>
        <div class="row" *ngIf="relationshipRole != 3 && relationshipRole != 4" style="margin-top: 10px; margin-bottom: 20px;">
          <div class="col-4 label_right">
            <app-label [Text]="localService.languageContent.user_authentication.relation_type"></app-label>
          </div>
          <div class="col-8">
            <ngx-select *ngIf="relationships" [(ngModel)]="wrapper.v2" [optionValueField]="'key'"
              [optionTextField]="'value'" [items]="relationships" (select)="onRoleSelect()" [noAutoComplete]="true">
            </ngx-select>
          </div>
        </div>
        <div class="row" *ngIf="!isForBusiness">
          <div class="col-6">
            <ngx-select *ngIf="localService.countryCodes" [(ngModel)]="countryId" [optionValueField]="'key'"
              [optionTextField]="'v1'" [items]="localService.countryCodes" [disabled]="true">
            </ngx-select>
          </div>
          <div [ngClass]="wrapper.value ? 'col-6 en' : 'col-6'">
            <input autocomplete="off" type="number" class="number" style="text-align:left;"
              (keypress)="localService.isNumberOnly($event,numericConfig)" id="{{elementIds.ph_num}}"
              [(ngModel)]="wrapper.value"
              placeholder="*{{localService.languageContent.user_authentication.contact_num}}" (input)="onInput(1)"
              (keydown.enter)="onPopupSave()"
              title="*{{localService.languageContent.user_authentication.contact_num}}" />
          </div>
        </div>
        <div class="row" *ngIf="!isForBusiness && !isOtpRequired">
          <div class="col-12">
            <div class="row">
              <div class="col-12" style="text-align:center;">
                <span>{{localService.languageContent.user_authentication.or}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-12" style="text-align:center;">
                <span class="button"
                  (click)="onPopupSave(true)">{{localService.languageContent.user_authentication.create_user}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="isForBusiness">
          <div *ngIf="!busineses">
            <div [ngClass]="wrapper.v3 == '' ? '' : 'en'">
              <input autocomplete="off" type="text" maxlength="50" id="{{elementIds.bin}}"
                placeholder="{{localService.languageContent.user_authentication.search_ph}}" [(ngModel)]="wrapper.v3"
                (input)="onInput(2)" title="{{localService.languageContent.user_authentication.search_ph}}"
                (keydown.enter)="onPopupSave()" style="width: calc(100% - 35px);" />
              <app-qr-scanner (onQrScanned)="onQrScanned($event)"></app-qr-scanner>
            </div>
          </div>
          <div *ngIf="busineses">
            <app-list-options [itemsWithCode]="busineses"
              [Title]="localService.languageContent.user_authentication.more_biz_found"
              (onSelectionChanged)="onBusinessSelected($event)"></app-list-options>
          </div>
        </div>
        <div class="row" *ngIf="brn != ''" style="color: darkgreen;">
          <div class="col-8">
            <span>{{localService.languageContent.user_authentication.brn}} : </span>
          </div>
          <div class="col-4">
            <span class="en">{{brn}}</span>
          </div>
        </div>
        <div class="row" *ngIf="isOtpRequired">
          <div class="col-md-12" style="text-align:center;font-weight:bold;">
            {{localService.languageContent.user_authentication.need_otp}}
          </div>
        </div>
        <div class="row" *ngIf="isOtpRequired">
          <div class="col-md-12" style="text-align:center">
            <app-otp-container [PhNumOrEmail]="wrapper.v4" (onVerified)="onVerifiedOtpVerified($event)"
              [otpType]="5"></app-otp-container>
          </div>
        </div>
        <div class="row" *ngIf="message != ''">
          <div class="col-md-12" style="color:red;text-align:justify;">
            {{message}}
          </div>
        </div>
      </div>
    </div>
    <div class="side_popup_footer" *ngIf="!isOtpRequired">
      <div class="row">
        <div class="col-12">
          <button type="button" class="btn btn-primary" id="{{userAuthSaveBtnId}}"
            (click)="onPopupSave()">{{localService.languageContent.common.save}}</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<div>
  <app-create-account *ngIf="ctryCode" [(isOpenPopup)]="isOpenCreateAccount" [BusinessId]="BusinessId"
    [isSetFromLogin]="true" [ctryCode]="ctryCode" (onClose)="onCloseCreateAccount($event)"
    [PhoneNumber]="wrapper.value ? wrapper.value.toString() : ''" [btnIdToTriggerWhileClose]="btnIdToTriggerWhileClose"></app-create-account>
</div>